module.exports = __webpack_public_path__ + "b097ba2f16190e1bdb75b13e2788e76f.svg";